// File Metadata:
// Filename: UserAvatar.jsx
// Version: 1.00
// Created: 2026-06-14
// Last Modified: 2026-06-14
// Authors: GitHub Copilot
// Description: User avatar button component for displaying user's profile picture or initial

import React from 'react';
import { IconButton, Tooltip, Avatar } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';

const UserAvatar = ({ user, onMenuOpen }) => {
  const theme = useTheme();
  
  return (
    <Tooltip title="Account menu" placement="bottom-end">
      <IconButton
        onClick={onMenuOpen}
        size="small"
        sx={{ ml: 0.5 }}
        aria-label="Account menu"
      >
        <Avatar
          src={user.avatar}
          alt={user.name}
          sx={{
            width: 36,
            height: 36,
            border: `2px solid ${alpha(theme.palette.primary.main, 0.5)}`,
            fontFamily: "'Bricolage Grotesque', 'Helvetica Neue', sans-serif",
            fontWeight: 700,
            fontSize: '0.85rem',
            bgcolor: alpha(theme.palette.primary.main, 0.2),
            color: theme.palette.primary.main,
          }}
        >
          {user.name?.[0]?.toUpperCase()}
        </Avatar>
      </IconButton>
    </Tooltip>
  );
};

export default UserAvatar;
